/**
 * The stored answer key of a mastermind: the code. Kept apart from the editor component so
 * the eagerly loaded module file never pulls the form into the bundle. While the author is
 * still choosing, a hole is null; the server refuses a key with a hole.
 */
import { lengthOf, type MastermindDefinition } from "./types";

export interface MastermindSolution {
  code: (number | null)[];
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function emptySolution(definition: MastermindDefinition): MastermindSolution {
  return { code: Array.from({ length: lengthOf(definition) }, () => null) };
}

/** Reads whatever is stored, however wrong, as one slot per peg of the definition. */
export function codeOf(definition: MastermindDefinition, value: unknown): (number | null)[] {
  const raw = isRecord(value) && Array.isArray(value.code) ? value.code : [];
  return Array.from({ length: lengthOf(definition) }, (_, i) => {
    const color = raw[i];
    return typeof color === "number" && Number.isInteger(color) && color >= 1 && color <= 8
      ? color
      : null;
  });
}
